import apiPropertyMasterDraft from '../api/PropertyMasterDraftAPI.js';
import apiPropertyMaster from '../api/PropertyMasterAPI.js';
import lib from './lib.js'

const invalid = (err) => {
    return {
        ok: false,
        err: err
    }
};

const validate = async (propertyMaster) => {
    if (!propertyMaster.name) return invalid('Property name is required');
    if (propertyMaster.name) {
        const propertyMasterFound = await apiPropertyMaster.isNameUnique(propertyMaster.name)
        if (propertyMasterFound === false) return invalid('Duplicate property name found');
    }
    if (!propertyMaster.title) return invalid('Property Category is required');
    if (!propertyMaster.type) return invalid('Property Type is required');
    if ((!propertyMaster.address.country) || (propertyMaster.address.country === 'Country')) return invalid('Please select country');
    if ((!propertyMaster.address.state) || (propertyMaster.address.state === 'State')) return invalid('Please select state');
    if ((!propertyMaster.address.area) || (propertyMaster.address.area === 'Area')) return invalid('Please select area');
    if (!propertyMaster.address.postcode) return invalid('Postcode is required');

    return {
        ok: true
    };
};

const id = async (id) => {
    const property = await apiPropertyMasterDraft.id(id);
    return property;
};

const save = async (property) => {
    const updatedProperty = await apiPropertyMasterDraft.save(property);
    return updatedProperty;
};

const search = async (agentId, val, status, paging) => {
    // console.log(val)
    const properties = await apiPropertyMasterDraft.search(agentId, val, status, paging);
    return properties;
};

export default {
    validate: validate,
    id: id,
    save: save,
    search: search,
};